import React, {
    useEffect,
    useState,
} from "react";

import {
    Link,
    useLocation,
} from "react-router-dom";

import {
    HashLink,
} from "react-router-hash-link";

import {
    FontAwesomeIcon,
} from "@fortawesome/react-fontawesome";

import {
    faYoutube,
    faFacebookF,
    faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import logoBlack from "../assets/images/logos/text_logo_black.png";

import {
    removeFromCart,
} from "../store/slices/cartSlice.ts";


const Header = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const [
        isSticky,
        setIsSticky,
    ] = useState(false);

    const [
        posWrapHeader,
        setPosWrapHeader,
    ] = useState(0);

    const [
        menuOpen,
        setMenuOpen,
    ] = useState(false);

    const [
        subMenuOpen,
        setSubMenuOpen,
    ] = useState({});

    const [
        cartVisible,
        setCartVisible,
    ] = useState(false);


    const cartItems = useSelector(
        (state) =>
            state.cart?.items || []
    );

    const isAuthenticated = useSelector(
        (state) =>
            state.auth?.isAuthenticated === true
    );

    const account = useSelector(
        (state) =>
            state.auth?.account || null
    );


    const isApprovedWholesale =
        account?.profile?.wholesale_status ===
            "approved" &&
        account?.profile?.is_wholesale === true;


    /*
     * The My Account link opens the future account page
     * when the user is logged in.
     */
    const accountPath = isAuthenticated
        ? "/account"
        : "/login";

    const accountLabel = isAuthenticated
        ? "My Account"
        : "Login";


    /*
     * The icon beside the cart is the authentication action:
     *
     * Logged out: Login
     * Logged in:  Logout
     */
    const authenticationPath =
        isAuthenticated
            ? "/logout"
            : "/login";

    const authenticationLabel =
        isAuthenticated
            ? "Logout"
            : "Login";


    const totalQuantity = cartItems.reduce(
        (total, item) =>
            total + Number(item.quantity || 0),
        0
    );

    const totalPrice = cartItems.reduce(
        (total, item) =>
            total +
            Number(item.price || 0) *
                Number(item.quantity || 0),
        0
    ).toFixed(2);


    const handleRemoveItem = (id) => {
        dispatch(
            removeFromCart(id)
        );
    };


    const toggleMobileMenu = () => {
        setMenuOpen(
            (current) => !current
        );
    };


    const closeMobileMenu = () => {
        setMenuOpen(false);
        setSubMenuOpen({});
    };


    const toggleSubMenu = (menuIndex) => {
        setSubMenuOpen(
            (current) => ({
                ...current,

                [menuIndex]:
                    !current[menuIndex],
            })
        );
    };


    const toggleCartVisibility = () => {
        setCartVisible(
            (current) => !current
        );
    };


    const handleCartKeyDown = (event) => {
        if (
            event.key === "Enter" ||
            event.key === " "
        ) {
            event.preventDefault();
            toggleCartVisibility();
        }
    };


    /*
     * Close the mobile menu when moving to the desktop
     * breakpoint.
     */
    useEffect(() => {
        const handleResize = () => {
            if (
                window.innerWidth >= 992
            ) {
                setMenuOpen(false);
                setSubMenuOpen({});
            }
        };

        window.addEventListener(
            "resize",
            handleResize
        );

        return () => {
            window.removeEventListener(
                "resize",
                handleResize
            );
        };
    }, []);


    /*
     * Determine when to use the sticky desktop header.
     */
    useEffect(() => {
        const topBarElement =
            document.querySelector(
                ".top-bar"
            );

        const topBarHeight =
            topBarElement
                ? topBarElement.clientHeight
                : 0;

        setPosWrapHeader(
            topBarHeight
        );

        const handleScroll = () => {
            setIsSticky(
                window.scrollY >
                    topBarHeight
            );
        };

        handleScroll();

        window.addEventListener(
            "scroll",
            handleScroll
        );

        return () => {
            window.removeEventListener(
                "scroll",
                handleScroll
            );
        };
    }, []);


    return (
        <header>
            {/* Desktop header */}
            <div
                className={
                    `container-menu-desktop ${
                        isSticky
                            ? "fix-menu-desktop"
                            : ""
                    }`
                }
            >
                {/* Top bar */}
                <div className="top-bar">
                    <div className="content-topbar flex-sb-m h-full container">
                        <div className="left-top-bar">
                            Free shipping for
                            standard orders over
                            $25 (USA)
                        </div>

                        <div className="right-top-bar flex-w h-full">
                            <HashLink
                                smooth
                                to="/#faq"
                                className="btn btn-link"
                            >
                                Help &amp; FAQs
                            </HashLink>

                            {!isAuthenticated ? (
                                /*
                                * Logged-out users see only Login.
                                */
                                <Link
                                    to="/login"
                                    className="flex-c-m trans-04 p-lr-25"
                                >
                                    Login
                                </Link>
                            ) : (
                                <>
                                    {/*
                                    * Logged-in users see both My Account
                                    * and Logout.
                                    */}
                                    <Link
                                        to="/account"
                                        className="flex-c-m trans-04 p-lr-25"
                                    >
                                        My Account
                                    </Link>

                                    <Link
                                        to="/logout"
                                        className="flex-c-m trans-04 p-lr-25"
                                    >
                                        Logout
                                    </Link>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* Desktop navigation */}
                <div className="wrap-menu-desktop">
                    <nav className="limiter-menu-desktop container">
                        {/* Logo */}
                        <Link
                            className="logo"
                            to="/"
                            aria-label="Molu home"
                        >
                            <img
                                src={logoBlack}
                                alt="Molu"
                            />
                        </Link>

                        {/* Main menu */}
                        <div className="menu-desktop">
                            <ul className="main-menu">
                                <li
                                    className={
                                        location.pathname ===
                                        "/"
                                            ? "active-menu"
                                            : ""
                                    }
                                >
                                    <Link to="/">
                                        Home
                                    </Link>
                                </li>

                                <li
                                    className={
                                        location.pathname ===
                                        "/shop"
                                            ? "active-menu"
                                            : ""
                                    }
                                >
                                    <Link to="/shop">
                                        Shop
                                    </Link>
                                </li>

                                {isApprovedWholesale ? (
                                    <li
                                        className={
                                            location.pathname.startsWith(
                                                "/wholesale/catalog"
                                            )
                                                ? "active-menu"
                                                : ""
                                        }
                                    >
                                        <Link to="/wholesale/catalog">
                                            Wholesale
                                        </Link>
                                    </li>
                                ) : null}

                                <li
                                    className={
                                        location.pathname.startsWith(
                                            "/blog"
                                        )
                                            ? "active-menu"
                                            : ""
                                    }
                                >
                                    <Link to="/blog">
                                        Blog
                                    </Link>
                                </li>

                                <li
                                    className={
                                        location.pathname.startsWith(
                                            "/about"
                                        )
                                            ? "active-menu"
                                            : ""
                                    }
                                >
                                    <Link to="/about">
                                        About
                                    </Link>
                                </li>

                                <li
                                    className={
                                        location.pathname.startsWith(
                                            "/glossary"
                                        )
                                            ? "active-menu"
                                            : ""
                                    }
                                >
                                    <Link to="/glossary">
                                        Glossary
                                    </Link>
                                </li>

                                <li
                                    className={
                                        location.pathname.startsWith(
                                            "/contact"
                                        )
                                            ? "active-menu"
                                            : ""
                                    }
                                >
                                    <Link to="/contact">
                                        Contact
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        {/* Social, authentication, and cart icons */}
                        <div className="wrap-icon-header flex-w flex-r-m">
                            <div
                                className={
                                    `header-social ${
                                        isSticky
                                            ? "fix-menu-social"
                                            : "fix-menu-social"
                                    }`
                                }
                            >
                                <a
                                    href="https://www.youtube.com/channel/UCUVzLhFqQzavjNhlsPOH4Bg"
                                    className="social-icon"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Molu on YouTube"
                                >
                                    <FontAwesomeIcon
                                        icon={
                                            faYoutube
                                        }
                                    />
                                </a>

                                <a
                                    href="https://www.facebook.com/people/Molu-Wellness/61576808587286/"
                                    className="social-icon"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Molu on Facebook"
                                >
                                    <FontAwesomeIcon
                                        icon={
                                            faFacebookF
                                        }
                                    />
                                </a>

                                <a
                                    href="https://www.instagram.com/moluwellness"
                                    className="social-icon"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Molu on Instagram"
                                >
                                    <FontAwesomeIcon
                                        icon={
                                            faInstagram
                                        }
                                    />
                                </a>
                            </div>

                            {/* Shopping cart */}
                            <div
                                className="icon-header-item cl2 hov-cl1 trans-04 p-l-11 p-r-11 icon-header-noti js-show-cart"
                                data-notify={
                                    totalQuantity
                                }
                                onClick={
                                    toggleCartVisibility
                                }
                                onKeyDown={
                                    handleCartKeyDown
                                }
                                role="button"
                                tabIndex={0}
                                aria-label="Open shopping cart"
                            >
                                <i
                                    className="zmdi zmdi-shopping-cart"
                                    style={{
                                        color:
                                            "#333",
                                    }}
                                />
                            </div>
                        </div>
                    </nav>
                </div>
            </div>

            {/* Mobile header */}
            <div className="wrap-header-mobile">
                {/* Mobile logo */}
                <div className="logo-mobile">
                    <Link
                        to="/"
                        aria-label="Molu home"
                    >
                        <img
                            src={logoBlack}
                            alt="Molu"
                        />
                    </Link>
                </div>

                {/* Mobile icons */}
                <div className="wrap-icon-header flex-w flex-r-m m-r-15">

                    {/* Mobile shopping cart */}
                    <div
                        className="icon-header-item cl2 hov-cl1 trans-04 p-l-10 p-r-11 icon-header-noti js-show-cart"
                        data-notify={
                            totalQuantity
                        }
                        onClick={
                            toggleCartVisibility
                        }
                        onKeyDown={
                            handleCartKeyDown
                        }
                        role="button"
                        tabIndex={0}
                        aria-label="Open shopping cart"
                    >
                        <i className="zmdi zmdi-shopping-cart" />
                    </div>
                </div>

                {/* Mobile menu button */}
                <div
                    className={
                        `btn-show-menu-mobile hamburger hamburger--squeeze ${
                            menuOpen
                                ? "is-active"
                                : ""
                        }`
                    }
                    onClick={
                        toggleMobileMenu
                    }
                    onKeyDown={(
                        event
                    ) => {
                        if (
                            event.key ===
                                "Enter" ||
                            event.key ===
                                " "
                        ) {
                            event.preventDefault();
                            toggleMobileMenu();
                        }
                    }}
                    role="button"
                    tabIndex={0}
                    aria-label="Toggle navigation menu"
                    aria-expanded={
                        menuOpen
                    }
                >
                    <span className="hamburger-box">
                        <span className="hamburger-inner" />
                    </span>
                </div>
            </div>

            {/* Mobile menu */}
            <div
                className={
                    `menu-mobile ${
                        menuOpen
                            ? "open"
                            : ""
                    }`
                }
                style={{
                    display:
                        menuOpen
                            ? "block"
                            : "none",
                }}
            >
                <ul className="topbar-mobile">
                    <li>
                        <div className="left-top-bar">
                            Free shipping for
                            standard orders over
                            $25 (USA)
                        </div>
                    </li>

                    <li>
                        <div className="right-top-bar flex-w h-full">
                            <HashLink
                                smooth
                                to="/#faq"
                                className="btn btn-link"
                                onClick={
                                    closeMobileMenu
                                }
                            >
                                Help &amp; FAQs
                            </HashLink>

                            <Link
                                to={accountPath}
                                className="flex-c-m p-lr-10 trans-04"
                                onClick={
                                    closeMobileMenu
                                }
                            >
                                {accountLabel}
                            </Link>
                        </div>
                    </li>
                </ul>

                <ul className="main-menu-m">
                    <li>
                        <Link
                            to="/"
                            onClick={
                                closeMobileMenu
                            }
                        >
                            Home
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/shop"
                            onClick={
                                closeMobileMenu
                            }
                        >
                            Shop
                        </Link>
                    </li>

                    {isApprovedWholesale ? (
                        <li>
                            <Link
                                to="/wholesale/catalog"
                                onClick={
                                    closeMobileMenu
                                }
                            >
                                Wholesale
                            </Link>
                        </li>
                    ) : null}

                    <li>
                        <Link
                            to="/blog"
                            onClick={
                                closeMobileMenu
                            }
                        >
                            Blog
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/about"
                            onClick={
                                closeMobileMenu
                            }
                        >
                            About
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/glossary"
                            onClick={
                                closeMobileMenu
                            }
                        >
                            Glossary
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/contact"
                            onClick={
                                closeMobileMenu
                            }
                        >
                            Contact
                        </Link>
                    </li>

                    {/* Account page or login */}
                    <li>
                        <Link
                            to={accountPath}
                            onClick={
                                closeMobileMenu
                            }
                        >
                            <i
                                className="zmdi zmdi-account-circle"
                                style={{
                                    marginRight:
                                        "8px",
                                }}
                            />

                            {accountLabel}
                        </Link>
                    </li>

                    {/* Separate logout entry */}
                    {isAuthenticated ? (
                        <li>
                            <Link
                                to="/logout"
                                onClick={
                                    closeMobileMenu
                                }
                            >
                                <i
                                    className="zmdi zmdi-power"
                                    style={{
                                        marginRight:
                                            "8px",
                                    }}
                                />

                                Logout
                            </Link>
                        </li>
                    ) : null}
                </ul>
            </div>

            {/* Search modal */}
            <div className="modal-search-header flex-c-m trans-04 js-hide-modal-search">
                <div className="container-search-header">
                    <button
                        type="button"
                        className="flex-c-m btn-hide-modal-search trans-04 js-hide-modal-search"
                    >
                        <img
                            src="/images/icons/icon-close2.png"
                            alt="Close"
                        />
                    </button>

                    <form className="wrap-search-header flex-w p-l-15">
                        <button
                            type="submit"
                            className="flex-c-m trans-04"
                            aria-label="Search"
                        >
                            <i className="zmdi zmdi-search" />
                        </button>

                        <input
                            className="plh3"
                            type="text"
                            name="search"
                            placeholder="Search..."
                        />
                    </form>
                </div>
            </div>

            {/* Cart sidebar */}
            <div
                className={
                    `wrap-header-cart js-panel-cart ${
                        cartVisible
                            ? "show-header-cart"
                            : ""
                    }`
                }
            >
                {cartVisible ? (
                    <div
                        className="s-full js-hide-cart"
                        onClick={
                            toggleCartVisibility
                        }
                        role="presentation"
                    />
                ) : null}

                <div className="header-cart flex-col-l p-l-65 p-r-25">
                    {/* Cart heading */}
                    <div className="header-cart-title flex-w flex-sb-m p-b-8">
                        <span className="mtext-103 cl2">
                            Your Cart
                        </span>

                        <div
                            className="fs-35 lh-10 cl2 p-lr-5 pointer hov-cl1 trans-04 js-hide-cart"
                            onClick={
                                toggleCartVisibility
                            }
                            onKeyDown={(
                                event
                            ) => {
                                if (
                                    event.key ===
                                        "Enter" ||
                                    event.key ===
                                        " "
                                ) {
                                    event.preventDefault();
                                    toggleCartVisibility();
                                }
                            }}
                            role="button"
                            tabIndex={0}
                            aria-label="Close shopping cart"
                        >
                            <i className="zmdi zmdi-close" />
                        </div>
                    </div>

                    {/* Cart contents */}
                    <div className="header-cart-content flex-w js-pscroll">
                        <ul className="header-cart-wrapitem w-full">
                            {cartItems.map(
                                (item) => (
                                    <li
                                        key={
                                            item.id
                                        }
                                        className="header-cart-item flex-w flex-t m-b-12"
                                    >
                                        <div className="header-cart-item-img">
                                            <img
                                                src={
                                                    item.image ||
                                                    "/default.jpg"
                                                }
                                                alt={
                                                    item.name
                                                }
                                            />
                                        </div>

                                        <div className="header-cart-item-txt p-t-8">
                                            <span className="header-cart-item-name m-b-18">
                                                {
                                                    item.name
                                                }
                                            </span>

                                            <span className="header-cart-item-info">
                                                {Number(
                                                    item.quantity ||
                                                        0
                                                )}{" "}
                                                × $
                                                {Number(
                                                    item.price ||
                                                        0
                                                ).toFixed(
                                                    2
                                                )}
                                            </span>

                                            <button
                                                type="button"
                                                onClick={() =>
                                                    handleRemoveItem(
                                                        item.id
                                                    )
                                                }
                                                className="btn btn-sm btn-danger mt-2"
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    </li>
                                )
                            )}
                        </ul>

                        <div className="w-full">
                            <div className="header-cart-total w-full p-tb-40">
                                Total: $
                                {totalPrice}
                            </div>

                            <div className="header-cart-buttons flex-w w-full">
                                <Link
                                    to="/shop/shopping-cart"
                                    className="flex-c-m stext-101 cl0 size-107 bg3 bor2 hov-btn3 p-lr-15 trans-04 m-r-8 m-b-10"
                                    onClick={
                                        toggleCartVisibility
                                    }
                                >
                                    View Cart
                                </Link>

                                <Link
                                    to="/shop/shopping-cart"
                                    className="flex-c-m stext-101 cl0 size-107 bg3 bor2 hov-btn3 p-lr-15 trans-04 m-b-10"
                                    onClick={
                                        toggleCartVisibility
                                    }
                                >
                                    Check Out
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};


export default Header;